import React from 'react';
import { Link } from 'react-router-dom';
import content from '../data/content.json';
import { resolveAssetPath, sortByOrderThenId } from '../utils/content';

const fallbackVideos = [
 
];

const videosFromContent = [...(content.videos ?? [])].sort(sortByOrderThenId);
const videos = videosFromContent.length ? videosFromContent : fallbackVideos;

const VideosPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#0b0b0b', color: '#fff', padding: '100px 5%' }}>
      <Link to="/#Works" style={{ color: '#ff41c8', textDecoration: 'none', marginBottom: '40px', display: 'inline-block' }} />

      <div style={{ display: 'flex', gap: '30px', overflowX: 'auto', paddingBottom: '40px' }}>
        {videos.map((video) => {
          const thumbnailSrc = resolveAssetPath(video.thumbnail);
          const videoUrl = video.video_url || resolveAssetPath(video.video_file);

          return (
            <div
              key={video.id}
              style={{
                minWidth: '400px',
                height: '250px',
                background: '#1a1a1a',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #333',
                transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
                cursor: 'pointer',
                flexShrink: 0,
                overflow: 'hidden',
                position: 'relative'
              }}
              onClick={() => {
                if (videoUrl) {
                  window.location.href = videoUrl;
                }
              }}
              onMouseEnter={(event) => {
                event.currentTarget.style.transform = 'scale(1)';
                event.currentTarget.style.boxShadow = '0 0 30px rgba(255, 65, 200, 0.2)';
                event.currentTarget.style.borderColor = '#47ff41ff';
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.transform = 'scale(1)';
                event.currentTarget.style.boxShadow = 'none';
                event.currentTarget.style.borderColor = '#333';
              }}
            >
              {thumbnailSrc ? (
                <img
                  src={thumbnailSrc}
                  alt={video.title || 'Video thumbnail'}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0
                  }}
                />
              ) : null}

              <div
                style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(255, 65, 200, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  zIndex: 2
                }}
              >
                <div
                  style={{
                    width: 0,
                    height: 0,
                    borderTop: '10px solid transparent',
                    borderBottom: '10px solid transparent',
                    borderLeft: '16px solid #ff41c8',
                    marginLeft: '6px'
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VideosPage;
